import React from "react";
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom';

// onChange(newRoute, oldRoute): function，网址改变时触发
//          newRoute, oldRoute


var getSearchParams = function getSearchParams(search) {
    if (!search) {
        search = location.search.substring(1);
    }
    var searchParams = {};
    if (search) {
        var arySearch = search.split('&');
        for (var i = 0; i < arySearch.length; i++) {
            var arySearchItem = arySearch[i].split('=');
            searchParams[arySearchItem[0]] = arySearchItem[1];
        }
    }
    return searchParams;
};

var appendSearchParams = function appendSearchParams(url, newParams) {
    var aryUrl = url.split('?'),
        search = aryUrl[1],
        oldParams = undefined;
    if (search) {
        oldParams = getSearchParams(search);
    } else {
        oldParams = {};
    }
    for (var k in newParams) {
        oldParams[k] = newParams[k];
    }
    var newSearch = '';
    for (var _k in oldParams) {
        if (newSearch) {
            newSearch += '&';
        }
        newSearch += _k + '=' + oldParams[_k];
    }
    return aryUrl[0] + '?' + newSearch;
};

export { getSearchParams, appendSearchParams };

var CONFIG = {};
// let CURROUTE = undefined;
var CURROUTECHILD = undefined;
// let NAVIGATE = undefined;

var RouteHander = function RouteHander(props) {
    var ps = useParams();

    if (props) {
        if (props.config) {
            CONFIG = Object.assign({}, CONFIG, props.config);
        }
    }

    // const navigateTo = (toUrl) => {
    //     navigate(toUrl);
    // };

    // useEffect(() => {
    //     NAVIGATE = useNavigate();
    // });

    var pathname = ps['*'];
    var search = location.search,
        fullpath = pathname + search;

    if (CURROUTECHILD && CURROUTECHILD.props.newRoute.url === fullpath) {
        return CURROUTECHILD;
    } else {
        search = search.substring(1);

        var searchParams = getSearchParams(search);

        var pname = pathname,
            ary = pathname.split('/'),
            _params = [];

        if (ary.length > 1) {
            pname = ary[0];
            for (var i = 1; i < ary.length; i++) {
                _params.push(ary[i]);
            }
        }

        var newRoute = {
            url: fullpath,
            pathname: pathname,
            search: search,
            name: pname,
            params: _params,
            searchParams: searchParams
        },
            oldRoute = CURROUTECHILD && CURROUTECHILD.props.newRoute || undefined;
        if (CONFIG.onChange && CONFIG.onChange instanceof Function) {
            CONFIG.onChange(newRoute, oldRoute);
        }
        CURROUTECHILD = React.createElement(props.children.type, Object.assign({}, props.children.props, { newRoute: newRoute, oldRoute: oldRoute }));
        return CURROUTECHILD;
    }
};

var EasyRouter = function EasyRouter(props) {
    return React.createElement(
        BrowserRouter,
        null,
        React.createElement(
            Routes,
            null,
            React.createElement(Route, { path: '*', element: React.createElement(RouteHander, props) })
        )
    );
};

export default EasyRouter;